/* ---------------------------------------------------------------------------
   Icons can't be serialised into JSON, so CMS content stores an icon *name*
   (e.g. "faHospital") and components resolve it here. Keep this list in step
   with the icons used across colleges.js / Facilities.js etc.; unknown names
   fall back to faLeaf so a bad value never crashes a render.
--------------------------------------------------------------------------- */
import {
  faLeaf,
  faStethoscope,
  faGraduationCap,
  faMicroscope,
  faXRay,
  faUserDoctor,
  faUserNurse,
  faEye,
  faChartLine,
  faLaptopCode,
  faShirt,
  faSpa,
  faScaleBalanced,
  faGavel,
  faHospital,
  faFlask,
  faBookOpen,
  faBuilding,
  faBus,
  faWifi,
  faDumbbell,
  faUtensils,
  faBed,
  faClipboardList,
  faMobileScreen,
  faMoneyBillWave,
  faIndianRupeeSign,
  faArrowRight,
  faRightFromBracket,
  faCertificate,
  faClock,
  faUserClock,
  faCalendarCheck,
  faMoneyBill,
} from "@fortawesome/free-solid-svg-icons";

export const ICONS = {
  faLeaf,
  faStethoscope,
  faGraduationCap,
  faMicroscope,
  faXRay,
  faUserDoctor,
  faUserNurse,
  faEye,
  faChartLine,
  faLaptopCode,
  faShirt,
  faSpa,
  faScaleBalanced,
  faGavel,
  faHospital,
  faFlask,
  faBookOpen,
  faBuilding,
  faBus,
  faWifi,
  faDumbbell,
  faUtensils,
  faBed,
  faClipboardList,
  faMobileScreen,
  faMoneyBillWave,
  faIndianRupeeSign,
  faArrowRight,
  faRightFromBracket,
  faCertificate,
  faClock,
  faUserClock,
  faCalendarCheck,
  faMoneyBill,
};

/** Resolve an icon name (or pass through an already-resolved icon object). */
export function resolveIcon(name) {
  if (!name) return faLeaf;
  if (typeof name === "object") return name; // already a FontAwesome icon
  return ICONS[name] || faLeaf;
}

/* Reverse lookup: an imported icon object -> its name. Used when serialising a
   bundled default into CMS-storable JSON (icons can't be JSON, so they become
   names, which resolveIcon turns back into the identical icon). */
const NAME_BY_ICON = new Map(Object.entries(ICONS).map(([name, icon]) => [icon, name]));

export function iconName(icon) {
  if (!icon) return "";
  if (typeof icon === "string") return icon;
  return NAME_BY_ICON.get(icon) || "";
}

export const ICON_NAMES = Object.keys(ICONS);
